/* TODO: need to change it after update Dashboard settings  */

import { computed, ref } from 'vue'
import { ILayoutItem } from '@/types/dashboard'
import cloneDeep from 'lodash/cloneDeep'
import { DEFAULT_FONT_SIZE, DEFAULT_LAYOUT_FONT_STYLE } from '@/enum/default-layout-config'
import { getLayoutLogo, getLayoutParameterByName } from '@/composables/globalData/useLayouts'

const previewLayoutState = ref<ILayoutItem | undefined>(undefined)

export const widgetPreviewGroupTitleStyles = computed(() => {
    const defaultSizeVar = DEFAULT_FONT_SIZE
    // const defaultColor = DEFAULT_FONT_COLOR
    const defaultFontSize = `${DEFAULT_FONT_SIZE}px`
    if (!previewLayoutState.value?.LayoutParametersList?.length) {
        return {
            '--size': defaultSizeVar,
            // color: defaultColor,
            fontSize: defaultFontSize,
        }
    }

    const fontSize = getLayoutParameterByName(previewLayoutState.value.LayoutParametersList,'WidgetGroupTitlesFontSize', 'Value') || defaultSizeVar
    // const color = getLayoutParameterByName(previewLayoutState.value.LayoutParametersList,'ColorWidgetGroupTitles', 'Value') || defaultColor

    return {
        '--size': fontSize,
        // color: String(color),
        fontSize: `${fontSize}px`,
    }
})
export const widgetPreviewTableHeaderFontSize = computed(() => {
    const defaultSizeVar = 16
    const defaultFontSize = `${defaultSizeVar}px`
    if (!previewLayoutState.value?.LayoutParametersList?.length) {
        return {
            fontSize: defaultFontSize,
        }
    }

    const fontSize = getLayoutParameterByName(previewLayoutState.value.LayoutParametersList, 'WidgetTableHeaderFontSize', 'Value') || defaultSizeVar

    return {
        fontSize: `${fontSize}px`,
    }
})
export const widgetPreviewTableContentFontSize = computed(() => {
    const defaultSizeVar = 16
    const defaultFontSize = `${defaultSizeVar}px`
    if (!previewLayoutState.value?.LayoutParametersList?.length) {
        return {
            fontSize: defaultFontSize,
        }
    }

    const fontSize = getLayoutParameterByName(previewLayoutState.value.LayoutParametersList, 'WidgetTableContentFontSize', 'Value') || defaultSizeVar

    return {
        fontSize: `${fontSize}px`,
    }
})
export const widgetPreviewHeaderTextFontSize = computed(() => {
    const defaultSizeVar = 22
    const defaultFontSize = `${defaultSizeVar}px`
    if (!previewLayoutState.value?.LayoutParametersList?.length) {
        return {
            fontSize: defaultFontSize,
        }
    }

    const fontSize = getLayoutParameterByName(previewLayoutState.value.LayoutParametersList, 'WidgetTitlesFontSize', 'Value') || defaultSizeVar

    return {
        fontSize: `${fontSize}px`,
    }
})
export const previewLayoutFontSize = computed(() => {
    const params = previewLayoutState.value?.LayoutParametersList || []
    const result = params.find((el) => el.LayoutParameterName === 'WidgetTitlesFontSize')
    if (result) {
        return {
            fontSize: `${result.Value}px`,
        }
    }

    return DEFAULT_LAYOUT_FONT_STYLE
})
export const previewLayoutLogo = computed(() => {
    return getLayoutLogo(previewLayoutState.value)
})
export const isPreviewLayout = computed(() => {
    return !!previewLayoutState.value
})

/* Methods */
export function getPreviewLayout () {
    return previewLayoutState.value
}
export function setPreviewLayout (data?: ILayoutItem) {
    previewLayoutState.value = cloneDeep(data)
}
export function updatePreviewLayout (data: ILayoutItem) {
    previewLayoutState.value = cloneDeep(data)
}
export function resetPreviewLayout () {
    previewLayoutState.value = undefined
}


